import styles from './StartBgVideoWord.module.css';

import bgVideo from '../../../assets/video/bgVideoWordStart.webm';
import bgPoster from '../../../assets/images/bgPosterWordStart.webp';
import { useEffect, useRef } from 'react';

export const StartBgVideoWord = ({ delay }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.classList.add(styles.unvisible);
      }
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={styles.bgVideoWrapper} ref={videoRef}>
      <video playsInline autoPlay="autoplay" muted="muted" poster={bgPoster}>
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
